/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyCounts {
    getFixupPrototypeFunction() { return PolicyCounts.fixupPrototype; }

    static newInstance(model: Partial<PolicyCounts>): PolicyCounts {
        let obj = Object.assign(new PolicyCounts(), model);
        PolicyCounts.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyCounts>): PolicyCounts {
        if (!model) return null;
        return PolicyCounts.newInstance(<PolicyCounts> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyCounts) {
        if (!obj) return;

        models.PolicyCounts.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyCounts): boolean {
        Object.setPrototypeOf(obj, PolicyCounts.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Number of policies which are in violation status.
     */
    violations: string;

    /**
     * Number of policies which are in success status.
     */
    success: string;

    /**
     * Number of policies which are in error status.
     */
    error: string;

    /**
     * Number of policies which are in in_progress status.
     */
    in_progress: string;

    /**
     * Number of policies which are not having any status or in none status
     */
    none: string;

}
